module.exports = __webpack_public_path__ + "static/img/login_bubble.713f3d2b.jpg";